import { render, staticRenderFns } from "./CartFooter.vue?vue&type=template&id=9cbff7ec&scoped=true"
import script from "./CartFooter.vue?vue&type=script&lang=js"
export * from "./CartFooter.vue?vue&type=script&lang=js"
import style0 from "./CartFooter.vue?vue&type=style&index=0&id=9cbff7ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cbff7ec",
  null
  
)

export default component.exports